module.exports = __webpack_public_path__ + "static/media/lesotho-shipping-map.a60e291d.jpg";